import React from 'react';

import { Grid } from '@material-ui/core';
import { TextField, SelectField, AddressField, SwitchField, Step } from '../SteppedForm';

import rules from './rules';

const StepKin = (props) => {
  return (
    <Step
      id="kin"
      title={props.getPersonalDetailsTitle('Next of Kin')}
      skip={(formdata) =>
        props.getApplicant().owneroperator === false || formdata.onboardingFor === 'vehicle'
      }>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField id="kin_name" label="Name" valid={rules.safeText} required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <SelectField
            id="kin_relationship"
            label="Relationship"
            values={props.config.kin_relationships}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="kin_phone"
            type="tel"
            label="Phone"
            inputProps={{ maxLength: 16 }}
            valid={rules.phone}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="composite">
            <AddressField
              id="kin_address"
              label="Address"
              country="AU"
              fetchDetails
              suppressOptional
              help={`If this person lives at the same address as you, please select "use Home Address"`}
              value={
                props.getApplicant().home_as_kin
                  ? props.getHomeAddress()
                  : props.getApplicant().kin_address
              }
              valid={(v) =>
                props.getApplicant().kin_address || props.getApplicant().home_as_kin
                  ? true
                  : 'Is a required field'
              }
              disabled={props.getApplicant().home_as_kin}
            />
            <SwitchField
              id="home_as_kin"
              label="Use Home Address"
              color="secondary"
              checked={props.getApplicant().home_as_kin ? true : false}
            />
          </div>
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepKin;
